import React from "react";

import { Helmet } from "react-helmet";

import SectionHeading from "../components/section-heading";
import ItemCard from "../components/item-card";
import "./home.css";

import mockup_border from "../Images/mockup_border.png";
import footer_img from "../Images/footer1.jpg";

import prod1 from "../Images/Products/prod1.png";
import prod2 from "../Images/Products/prod2.png";
import prod3 from "../Images/Products/prod3.png"

import art1 from "../Images/Artwork/art2.jpg";
import art2 from "../Images/Artwork/art3.jpg";
import art3 from "../Images/Artwork/art4.jpg";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>MOUNT STUDIOS</title>
        <meta property="og:title" content="MOUNT STUDIOS" />
      </Helmet>
      <div className="home-navbar">
        <header data-role="Header" className="home-header max-width-container">
          <div className="home-navbar1">
            <div className="home-middle">
              <div className="home-left">
                <span className="navbar-link">SHOP</span>
                <span className="navbar-link">LOOKBOOK</span>
                <span className="navbar-link">SPECIAL</span>
              </div>
              <span className="navbar-logo-title">MOUNT STUDIOS</span>
              <div className="home-right">
                <span className="navbar-link">ABOUT</span>
                <span className="navbar-link">ITEMS</span>
                <span className="navbar-link">CONTACT</span>
              </div>
            </div>
            <div className="home-icons">
              <img
                alt="iconsbxscart3271299"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTIxLjgyMiA3LjQzMUMyMS42MzUgNy4xNjEgMjEuMzI4IDcgMjEgN0g3LjMzM0w2LjE3OSA0LjIzQzUuODY3IDMuNDgyIDUuMTQzIDMgNC4zMzMgM0gyVjVINC4zMzNMOS4wNzcgMTYuMzg1QzkuMjMyIDE2Ljc1NyA5LjU5NiAxNyAxMCAxN0gxOEMxOC40MTcgMTcgMTguNzkgMTYuNzQxIDE4LjkzNyAxNi4zNTJMMjEuOTM3IDguMzUyQzIyLjA1MiA4LjA0NCAyMi4wMDkgNy43IDIxLjgyMiA3LjQzMVonIGZpbGw9JyMxNjE2MTYnLz4KPHBhdGggZD0nTTEwLjUgMjFDMTEuMzI4NCAyMSAxMiAyMC4zMjg0IDEyIDE5LjVDMTIgMTguNjcxNiAxMS4zMjg0IDE4IDEwLjUgMThDOS42NzE1NyAxOCA5IDE4LjY3MTYgOSAxOS41QzkgMjAuMzI4NCA5LjY3MTU3IDIxIDEwLjUgMjFaJyBmaWxsPScjMTYxNjE2Jy8+CjxwYXRoIGQ9J00xNy41IDIxQzE4LjMyODQgMjEgMTkgMjAuMzI4NCAxOSAxOS41QzE5IDE4LjY3MTYgMTguMzI4NCAxOCAxNy41IDE4QzE2LjY3MTYgMTggMTYgMTguNjcxNiAxNiAxOS41QzE2IDIwLjMyODQgMTYuNjcxNiAyMSAxNy41IDIxWicgZmlsbD0nIzE2MTYxNicvPgo8L3N2Zz4K"
                className="home-image"
              />
              <img
                alt="iconsbxsheartcircle3271300"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTEyIDJDNi40ODYgMiAyIDYuNDg2IDIgMTJDMiAxNy41MTQgNi40ODYgMjIgMTIgMjJDMTcuNTE0IDIyIDIyIDE3LjUxNCAyMiAxMkMyMiA2LjQ4NiAxNy41MTQgMiAxMiAyWk0xNi4xODYgMTIuNzRMMTIgMTYuOTI2TDcuODE0IDEyLjc0QzYuNzI1IDExLjY1MiA2LjcyNSA5LjkyNyA3LjgxNCA4LjgzM0M4LjkwOCA3Ljc0NSAxMC42MzIgNy43NDUgMTEuNzIgOC44MzNMMTIgOS4xMTJMMTIuMjc5IDguODMzQzEzLjM2NyA3Ljc0NSAxNS4wOTIgNy43NDUgMTYuMTg1IDguODMzQzE3LjI3NCA5LjkyNyAxNy4yNzQgMTEuNjUxIDE2LjE4NiAxMi43NFonIGZpbGw9JyMxNjE2MTYnLz4KPC9zdmc+Cg=="
                className="home-image1"
              />
              <img
                alt="AccountCircle3271301"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTIgNUMxMy42NiA1IDE1IDYuMzQgMTUgOEMxNSA5LjY2IDEzLjY2IDExIDEyIDExQzEwLjM0IDExIDkgOS42NiA5IDhDOSA2LjM0IDEwLjM0IDUgMTIgNVpNMTIgMTkuMkM5LjUgMTkuMiA3LjI5IDE3LjkyIDYgMTUuOThDNi4wMyAxMy45OSAxMCAxMi45IDEyIDEyLjlDMTMuOTkgMTIuOSAxNy45NyAxMy45OSAxOCAxNS45OEMxNi43MSAxNy45MiAxNC41IDE5LjIgMTIgMTkuMlonIGZpbGw9JyMxNjE2MTYnLz4KPC9zdmc+Cg=="
                className="home-image2"
              />
            </div>
          </div>
          <div data-role="BurgerMenu" className="home-burger-menu">
            <svg viewBox="0 0 1024 1024" className="home-icon">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div data-role="MobileMenu" className="home-mobile-menu">
            <div className="home-nav">
              <div className="home-container01">
                <span className="home-logo-center1">MOUNT STUDIOS</span>
                <div
                  data-role="CloseMobileMenu"
                  className="home-close-mobile-menu"
                >
                  <svg viewBox="0 0 1024 1024" className="home-icon02">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <div className="home-middle1">
                <span className="home-text06">SHOP</span>
                <span className="home-text07">LOOKBOOK</span>
                <span className="home-text08">SPECIAL</span>
                <span className="home-text09">ABOUT</span>
                <span className="home-text10">BLOG</span>
                <span className="home-text11">CONTACT</span>
              </div>
            </div>
            <div>
              <svg viewBox="0 0 950.8571428571428 1024" className="home-icon04">
                <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
              </svg>
              <svg viewBox="0 0 877.7142857142857 1024" className="home-icon06">
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
              <svg viewBox="0 0 602.2582857142856 1024" className="home-icon08">
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </div>
          </div>
        </header>
      </div>
      <div className="home-main">
        <div className="home-hero section-container">
          <div className="home-max-width max-width-container">
            <div className="home-hero1">
              <div className="home-container02">
                <div className="home-info">
                  <img
                    alt="Rectangle43271305"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMicgaGVpZ2h0PSc1Micgdmlld0JveD0nMCAwIDIgNTInIGZpbGw9J25vbmUnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+CjxyZWN0IHdpZHRoPScyJyBoZWlnaHQ9JzUyJyBmaWxsPSdibGFjaycgZmlsbC1vcGFjaXR5PScwLjUnLz4KPC9zdmc+Cg=="
                    className="home-image3"
                  />
                  <span className="home-text12">
                    <span>HOME DECOR</span>
                    <br></br>
                    <span>trends - 2023</span>
                  </span>
                </div>
                <h1 className="home-text16 Heading-1">Tabletop Frames</h1>
                <div className="home-container03">
                  <span className="home-text17">FROM</span>
                  <span className="home-text18">$339</span>
                </div>
                <div className="home-btn-group">
                  <button className="button">Explore the collection</button>
                </div>
              </div>
              <img src={mockup_border} className="home-image5" alt="" />
            </div>
          </div>
        </div>
        <div className="section-container column">
          <div className="home-banner">
            <div className="home-container04">
              <h3 className="home-text19 Heading-3">MOUNT</h3>
              <span className="home-text20">
                <span></span>
                <span>studios</span>
              </span>
            </div>
          </div>
          <div className="home-container05 max-width-container">
            <div className="home-container06">
              <span className="home-text23">
                <span>Mount Studios: Mounting Your Memories</span>
                <br></br>
                <span>Preserving Moments, since 2019.</span>
                <br></br>
                <span>
                  Transform your cherished moments into personalized scribble
                  art masterpieces. Our talented artists craft vibrant designs,
                  capturing the essence of your memories. Customize color,
                  style, and add personal touches. Celebrate and preserve your
                  precious moments with Mount Studios, where memories become
                  art.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </span>
              <img
                alt="M3271427"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTk5JyBoZWlnaHQ9JzIwMCcgdmlld0JveD0nMCAwIDE5OSAyMDAnIGZpbGw9J25vbmUnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+CjxwYXRoIGQ9J00zNy4zMDI2IDcxLjI5MjVMOTkuMzgyNyAxODIuMzEzTDE2MS40NjMgNzEuMjkyNUwxNzUuNjIyIDIwMEgxOTguNzY1TDE3NS42MjIgMEw5OS4zODI3IDEzNy45NTlMMjMuMTQzOSAwTDAgMjAwSDIzLjE0MzlMMzcuMzAyNiA3MS4yOTI1WicgZmlsbD0nYmxhY2snIGZpbGwtb3BhY2l0eT0nMC4wNicvPgo8L3N2Zz4K"
                className="home-svg"
              />
              <button className="button">Read more</button>
            </div>
          </div>
        </div>
        <div className="section-container">
          <div className="max-width-container">
            <SectionHeading></SectionHeading>
            <div className="home-gallery">
              <div className="home-right1">
                <div className="home-top">
                  <div className="home-left2">
                    <ItemCard
                      name="Modern Frames"
                      image_src={prod1}
                      rootClassName="rootClassName2"
                      value={399.99}
                      stars={3}
                    ></ItemCard>
                  </div>
                  <div className="home-left2">
                    <ItemCard
                      name="Canvas Prints"
                      image_src={prod2}
                      rootClassName="rootClassName2"
                      value={349.99}
                      stars={5}
                    ></ItemCard>
                  </div>
                  <div className="home-left2">
                    <ItemCard
                      name="Deep Set Frames"
                      image_src={prod3}
                      rootClassName="rootClassName2"
                      value={449.99}
                      stars={4}
                    ></ItemCard>
                  </div>
                </div>
                <div className="home-bottom">
                  <div className="home-left2">
                    <ItemCard
                      name="Vector Illutration"
                      image_src={art1}
                      rootClassName="rootClassName2"
                      value={249.99}
                      stars={4}
                    ></ItemCard>
                  </div>
                  <div className="home-left2">
                    <ItemCard
                      name="Scribble Art"
                      image_src={art2}
                      rootClassName="rootClassName2"
                      value={299.99}
                      stars={5}
                    ></ItemCard>
                  </div>
                  <div className="home-left2">
                    <ItemCard
                      name="Caricatures"
                      image_src={art3}
                      rootClassName="rootClassName2"
                      value={299.99}
                      stars={4}
                    ></ItemCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-full-width-banner section-container">
          <div className="home-left4">
            <div className="home-content">
              <span className="home-text29">WALLART</span>
              <span className="home-text30">
                Carefully curated ary, well matched in style and looks
              </span>
            </div>
            <div className="home-btn button">
              <span className="home-text31">Explore now</span>
            </div>
          </div>
          <img
            alt="Rectangle13271410"
            src={footer_img}
            className="home-image5"
          />
        </div>
      </div>
      <div className="home-footer">
        <div className="max-width-container">
          <footer className="home-footer1">
            <div className="home-container07">
              <h3 className="home-text32 Heading-3">MOUNT STUDIOS</h3>
              <span className="home-text33">
                <span>K3B 100, Kalinga Vihar, Ghatikia</span>
                <br></br>
                <span>Bhubaneswar, India</span>
              </span>
              <span className="home-text36">(+91) 63701-06855</span>
              <span className="home-text37">mountstudios7@gmail.com</span>
            </div>
            <div className="home-links-container">
              <div className="home-container08">
                <span className="home-text38">Categories</span>
                <span className="home-text39">Modern Frames</span>
                <span className="home-text40">Canvas Prints</span>
                <span className="home-text41">Deepset Frames</span>
                <span className="home-text42">Illustrations</span>
                <span className="home-text43">Scribble Art</span>
                <span className="home-text44">Caricatures</span>
              </div>
              <div className="home-container09">
                <span className="home-text45">Company</span>
                <span className="home-text46">Shop</span>
                <span className="home-text47">Lookbook</span>
                <span className="home-text48">Specials</span>
                <span className="home-text49">About</span>
                <span className="home-text50">Blog</span>
              </div>
              <div className="home-container10">
                <span className="home-text51">Resources</span>
                <span className="home-text52">Contact us</span>
                <span className="home-text53">Order</span>
                <span className="home-text54">Track your order</span>
                <span className="home-text55">Shipping &amp; Delivery</span>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Home;
